import { render, staticRenderFns } from "./DamageAssessorCasePhotosCard.vue?vue&type=template&id=37cfc577&scoped=true"
import script from "./DamageAssessorCasePhotosCard.vue?vue&type=script&lang=js"
export * from "./DamageAssessorCasePhotosCard.vue?vue&type=script&lang=js"
import style0 from "./DamageAssessorCasePhotosCard.vue?vue&type=style&index=0&id=37cfc577&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cfc577",
  null
  
)

export default component.exports